import idGenerator from '../../util/aactools/idGenerator';

export function replace(items = [], replacement, options = {}) {
  const pos =
    options.replaceFakes && !idGenerator.hasRealId(replacement)
      ? items.findIndex(item => !idGenerator.hasRealId(item))
      : items.findIndex(item => item.itemid === replacement.itemid);
  if (pos !== -1) {
    items[pos] = replacement;
    return;
  }
  items.forEach(item => replace(item.items, replacement, options));
}
